module.exports = __webpack_public_path__ + "img/demo04.97655aab.png";